import { render, staticRenderFns } from "./LoansServicesView.vue?vue&type=template&id=a8d30978"
import script from "./LoansServicesView.vue?vue&type=script&lang=js"
export * from "./LoansServicesView.vue?vue&type=script&lang=js"
import style0 from "./LoansServicesView.vue?vue&type=style&index=0&id=a8d30978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports